"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var d3_1 = require("d3");
var shape_1 = require("./shape");
var svg_helper_1 = require("../lib/svg-helper");
var DEFAULT_LABEL_TEXT_HEIGHT = 14;
var Pie = /** @class */ (function (_super) {
    tslib_1.__extends(Pie, _super);
    function Pie(ctx, coord, helpers) {
        var _this = _super.call(this, ctx, coord, helpers) || this;
        _this.radius = 0;
        _this.innerRadius = 0;
        _this.labelTextHeight = 0;
        var _a = _this.coordinate, width = _a.width, height = _a.height;
        _this.radius = Math.min(width, height) / 2;
        _this.ctx.on("legend.hover", _this.onLegendItemHover, _this);
        _this.ctx.on("legend.left", _this.onLegendItemLeft, _this);
        _this.ctx.on("legend.clicked", _this.onLegendClick, _this);
        _this.ctx.on("plot.mouse.left", function () {
            _this.helpers.tooltip.hide();
        });
        return _this;
    }
    /**
     * 开始监听事件
     */
    Pie.prototype.start = function () {
        var _this = this;
        var classPrefix = this.ctx.theme.classPrefix;
        if ("ontouchstart" in document) {
            this.seriesGroup
                .selectAll("." + this.ctx.classPrefix + "-chart-series")
                .selectAll("path")
                .style("-webkit-tap-highlight-color", "transparent")
                .on("touchmove", this.showHover.bind(this))
                .on("touchend", this.hideHover.bind(this))
                .on("click", this.onClick.bind(this));
            this.seriesGroup.on("touchend", function () {
                if (d3_1.event &&
                    d3_1.event.relatedTarget &&
                    d3_1.event.relatedTarget.className !== classPrefix + "-chart-tooltip") {
                    _this.helpers.tooltip.hide();
                }
            });
        }
        else {
            this.seriesGroup
                .selectAll("." + this.ctx.classPrefix + "-chart-series")
                .selectAll("path")
                .on("mousemove", this.showHover.bind(this))
                .on("mouseleave", this.hideHover.bind(this))
                .on("click", this.onClick.bind(this));
            this.seriesGroup.on("mouseleave", function () {
                if (d3_1.event.relatedTarget &&
                    d3_1.event.relatedTarget.className !== classPrefix + "-chart-tooltip") {
                    _this.helpers.tooltip.hide();
                }
            });
        }
    };
    Pie.prototype.position = function (pos) {
        this.model.source(this.ctx.dataSource);
        if (typeof pos === "string") {
            this.valueKey = pos;
        }
        return this;
    };
    Pie.prototype.color = function (color) {
        if (typeof color === "string") {
            this.serieKey = color;
        }
        else if (Array.isArray(color)) {
            this.ctx.theme.color = color;
        }
        else if (typeof color === "object" && color !== null && color.key) {
            var key = color.key, formatter = color.formatter, colors = color.colors;
            this.serieKey = key;
            if (colors) {
                this.ctx.theme.color = colors;
            }
            else {
                this.ctx.theme.color = null;
            }
            if (formatter) {
                this.colorAttrCallback = formatter;
            }
        }
        else {
            this.serieKey = null;
        }
        this.colorKey = this.serieKey;
        return this;
    };
    Pie.prototype.coord = function (cfg) {
        var innerRadius = cfg.innerRadius;
        // 如果 innerRadius 是小于 1 的数字或百分比的字符串，代表是百分比系数，否则则认为是具体的数值
        if (typeof innerRadius === "number") {
            this.innerRadius = innerRadius;
        }
        return this;
    };
    Pie.prototype.updateModel = function () {
        this.model.define("default", this.valueKey, this.serieKey, this.colorKey);
    };
    Pie.prototype.updateColorScale = function () {
        var _this = this;
        var colorDomain = this.model.getKeyNames(this.colorKey);
        // series 需要按照值大小排序
        colorDomain = colorDomain.sort(function (a, b) {
            var prev = _this.model.getByAll("default", a);
            var next = _this.model.getByAll("default", b);
            return next - prev;
        });
        // 设置每个系列的颜色
        var _a = this.ctx.theme, color = _a.color, defaultColor = _a.defaultColor;
        var colorRange = [];
        if (typeof color === "function") {
            for (var i = 0; i < colorDomain.length; i++) {
                colorRange.push(color(colorDomain[i], i, i === colorDomain.length - 1));
            }
        }
        else if (Array.isArray(color)) {
            colorRange = color;
        }
        else {
            colorRange = defaultColor;
        }
        this.colorScale = d3_1.scaleOrdinal()
            .domain(colorDomain)
            .range(colorRange);
    };
    Pie.prototype.draw = function (updateModel) {
        if (updateModel === void 0) { updateModel = true; }
        if (updateModel)
            this.updateModel();
        this.updateColorScale();
        // 先更新图例的位置
        this.helpers.legend.update(this.colorScale, this.valueKey, "pie", this.model);
        this.coordinate.draw();
        this.drawSeries();
        this.start();
    };
    Pie.prototype.drawSeries = function () {
        var _this = this;
        var enable = this.ctx.getOption("interaction.element-select");
        var _a = this.coordinate, width = _a.width, height = _a.height;
        this.radius = Math.min(width, height) / 2;
        // series 需要按照值大小排序
        var seriesDomain = this.model.getSerieNames().sort(function (a, b) {
            var prev = _this.model.getByAll("default", a);
            var next = _this.model.getByAll("default", b);
            return next - prev;
        });
        var pieInstance = d3_1.pie()
            .value(function (col) {
            return _this.model.get("default", col);
        })
            .sort(null);
        var buildData = pieInstance(seriesDomain);
        // 这里处理下所有值都为空的情况
        var totalCount = buildData.reduce(function (pre, data) { return pre + data.value; }, 0);
        if (totalCount === 0) {
            var seriesDomainCount = seriesDomain.length;
            var emptyShowData = Array(seriesDomainCount).fill(1);
            var emptyPieInstance_1 = d3_1.pie()(emptyShowData);
            buildData = buildData.map(function (item, index) {
                item.startAngle = emptyPieInstance_1[index].startAngle;
                item.endAngle = emptyPieInstance_1[index].endAngle;
                return item;
            });
        }
        this.seriesGroup.selectAll("g").remove();
        this.seriesGroup
            .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
            .append("g")
            .attr("class", this.ctx.classPrefix + "-chart-series " + this.ctx.classPrefix + "-chart-pie-series")
            .call(function (g) {
            _this.arcInstance = d3_1.arc()
                .innerRadius(_this.innerRadius < 1
                ? _this.radius * _this.innerRadius
                : _this.innerRadius)
                .outerRadius(_this.radius * 0.82);
            g.selectAll("path")
                .data(buildData)
                .join("path")
                .style("cursor", enable ? "pointer" : "normal")
                .transition()
                .duration(500)
                .attr("class", function (d) { return _this.ctx.classPrefix + "-chart-point color-" + d.index; })
                .attr("d", _this.arcInstance)
                .attr("fill", function (d) { return _this.colorScale(d.data); });
        });
        // 绘制 Hover 图形
        this.hoverArcInstance = d3_1.arc()
            .innerRadius(this.radius * 0.82)
            .outerRadius(this.radius * 0.9);
        this.seriesGroup
            .append("g")
            .attr("class", this.ctx.classPrefix + "-chart-series " + this.ctx.classPrefix + "-chart-pie-series")
            .call(function (g) {
            g.selectAll("path")
                .data(buildData)
                .join("path")
                .attr("class", function (d) { return _this.ctx.classPrefix + "-chart-halo color-" + d.index; })
                .attr("data-index", function (d) { return d.index; })
                .attr("d", _this.hoverArcInstance)
                .attr("fill", function (d) {
                var color;
                if (_this.colorAttrCallback) {
                    color = _this.colorAttrCallback(d);
                }
                return color || _this.colorScale(d.data);
            })
                .style("opacity", "0");
        });
        this.drawDataLabels(buildData);
        return this;
    };
    Pie.prototype.drawDataLabels = function (data) {
        var _this = this;
        var _a = this.options.dataLabels, enable = _a.enable, formatter = _a.formatter;
        var labelArcInstance = d3_1.arc()
            .innerRadius(this.radius * 0.9)
            .outerRadius(this.radius * 0.9);
        var _b = this.ctx, root = _b.root, classPrefix = _b.classPrefix;
        var labelGroup = root
            .selectAll("." + classPrefix + "-chart-data-labels")
            .data(data)
            .join("g")
            .attr("class", function (_, i) {
            return classPrefix + "-chart-data-labels " + classPrefix + "-chart-series-" + i;
        })
            .attr("data-z-index", 6)
            .attr("transform", this.seriesGroup.attr("transform"));
        labelGroup.selectAll("g").remove();
        labelGroup.selectAll("path").remove();
        if (!enable)
            return;
        var midAngle = function (d) {
            return d.startAngle + (d.endAngle - d.startAngle) / 2;
        };
        var labels = labelGroup
            .append("g")
            .attr("class", classPrefix + "-chart-label " + classPrefix + "-data-label")
            .attr("data-z-index", 1);
        var totalCount = data.reduce(function (pre, d) { return pre + d.value; }, 0);
        labels
            .append("text")
            .attr("data-z-index", 1)
            .attr("dy", "0.35em")
            .style("text-anchor", function (d) {
            return midAngle(d) < Math.PI ? "start" : "end";
        })
            .style("font-size", "11px")
            .style("font-weight", "bold")
            .text(function (d, i) {
            var percentage = totalCount === 0 ? 0 : getPercentage(d.startAngle, d.endAngle);
            if (typeof formatter === "function") {
                return formatter(d.value, i, {
                    value: d.value,
                    percent: totalCount === 0 ? 0 : getPercentage(d.startAngle, d.endAngle),
                    serieName: d.data,
                    colorName: _this.colorScale(d.data),
                });
            }
            return d.value + " (" + percentage + "%)";
        });
        // 获取label高度
        var labelNodes = labels.nodes();
        if (labelNodes && labelNodes.length > 0 && !this.labelTextHeight) {
            this.labelTextHeight = Math.ceil(svg_helper_1.nodeHeight(labelNodes[0]));
        }
        else {
            this.labelTextHeight = DEFAULT_LABEL_TEXT_HEIGHT;
        }
        // 调整label位置
        var yAxiesValues = {};
        var dataLength = data.length;
        var lastYAxiesValue;
        for (var i = dataLength - 1; i > 0; i--) {
            var pos = labelArcInstance.centroid(data[i]);
            var x = this.radius * (midAngle(data[i]) < Math.PI ? 1 : -1);
            if (i === dataLength - 1) {
                // eslint-disable-next-line prefer-destructuring
                lastYAxiesValue = pos[1];
            }
            else if (x < 0 && pos[1] - lastYAxiesValue < this.labelTextHeight) {
                lastYAxiesValue += this.labelTextHeight;
                yAxiesValues[i] = lastYAxiesValue;
            }
        }
        labels.attr("transform", function (d, index) {
            var pos = labelArcInstance.centroid(d);
            var x = _this.radius * (midAngle(d) < Math.PI ? 1 : -1);
            var y = typeof yAxiesValues[index] !== "undefined"
                ? yAxiesValues[index]
                : pos[1];
            return "translate(" + x + ", " + y + ")";
        });
        labelGroup
            .append("path")
            .attr("class", classPrefix + "-data-connector")
            .attr("d", function (d, index) {
            var firstPoint = _this.arcInstance.centroid(d);
            var secondPoint = labelArcInstance.centroid(d);
            var threePoint = labelArcInstance.centroid(d);
            threePoint[0] = _this.radius * 0.95 * (midAngle(d) < Math.PI ? 1 : -1);
            if (typeof yAxiesValues[index] !== "undefined") {
                threePoint[1] = yAxiesValues[index];
                var endAngle = d.startAngle + (d.endAngle - d.startAngle) / 2;
                var fitSecondPointData = Object.assign({}, d, { endAngle: endAngle });
                secondPoint = labelArcInstance.centroid(fitSecondPointData);
            }
            return d3_1.line()([firstPoint, secondPoint, threePoint]);
        })
            .attr("fill", "none")
            .attr("stroke", function (d) {
            return _this.colorScale(d.data);
        })
            .attr("stroke-width", 1);
    };
    Pie.prototype.onClick = function (_a) {
        var data = _a.data, index = _a.index, value = _a.value, endAngle = _a.endAngle, startAngle = _a.startAngle;
        // eslint-disable-next-line no-unused-expressions
        d3_1.event && d3_1.event.preventDefault();
        var enable = this.ctx.getOption("interaction.element-select");
        if (enable) {
            this.drawSelected(index);
            var x = d3_1.event && d3_1.event.layerX;
            var y = d3_1.event && d3_1.event.layerY;
            var _b = this, valueKey = _b.valueKey, model = _b.model, colorScale = _b.colorScale, serieKey_1 = _b.serieKey;
            var alias = this.ctx.getOption("scale." + valueKey + ".alias");
            var label = alias || data.key === "default" ? valueKey : data;
            this.ctx.emit("interaction.selected", {
                x: x,
                y: y,
                xPos: x,
                index: index,
                metaData: [
                    {
                        value: value,
                        title: label,
                        color: colorScale(data),
                        percentage: getPercentage(startAngle, endAngle),
                        row: model
                            .getDataFromCategoryName("default")
                            .find(function (d) { return d[serieKey_1] === data; }),
                    },
                ],
            });
        }
    };
    Pie.prototype.drawSelected = function (index) {
        this.seriesGroup
            .selectAll("." + this.ctx.classPrefix + "-chart-point")
            .transition()
            .duration(500)
            .attr("d", this.arcInstance);
        var arcInstance = d3_1.arc()
            .innerRadius(this.innerRadius < 1 ? this.radius * this.innerRadius : this.innerRadius)
            .outerRadius(this.radius * 0.9);
        this.seriesGroup
            .select("." + this.ctx.classPrefix + "-chart-point.color-" + index)
            .transition()
            .duration(500)
            .attr("d", arcInstance);
    };
    /**
     * 显示辅助点
     */
    Pie.prototype.showHover = function (_a) {
        var data = _a.data, index = _a.index, value = _a.value, endAngle = _a.endAngle, startAngle = _a.startAngle;
        this.seriesGroup
            .selectAll("." + this.ctx.classPrefix + "-chart-series")
            .selectAll("." + this.ctx.classPrefix + "-chart-halo")
            .style("opacity", 0);
        this.seriesGroup
            .selectAll("." + this.ctx.classPrefix + "-chart-series")
            .select("." + this.ctx.classPrefix + "-chart-halo[data-index=\"" + index + "\"]")
            .style("opacity", 0.3);
        // eslint-disable-next-line no-unused-expressions
        d3_1.event && d3_1.event.preventDefault();
        var x = d3_1.event && d3_1.event.offsetX;
        var y = d3_1.event && d3_1.event.offsetY;
        var _b = this, valueKey = _b.valueKey, model = _b.model, colorScale = _b.colorScale, serieKey = _b.serieKey;
        var alias = this.ctx.getOption("scale." + valueKey + ".alias");
        var label = alias || data.key === "default" ? valueKey : data;
        var dataLeaf = model
            .getDataFromCategoryName("default")
            .find(function (d) { return d[serieKey] === data; });
        var metaData = [
            {
                value: value,
                valueText: typeof value === "number" ? d3_1.format(",")(value) : "-",
                title: label,
                color: colorScale(data),
                percentage: value === 0 ? 0 : getPercentage(startAngle, endAngle),
                row: dataLeaf ? dataLeaf.origin : null,
            },
        ];
        var tooltipEnable = this.ctx.getOption("tooltip.enable");
        if (tooltipEnable) {
            var allData = this.model.getAllData();
            this.helpers.tooltip.show({
                x: x,
                y: y,
                category: undefined,
                index: index,
                metaData: metaData,
            }, allData);
        }
        if (this.ctx.getOption("interaction.element-hover")) {
            if (this.currentHoverIndex !== index) {
                this.ctx.emit("interaction.hover", metaData);
                this.currentHoverIndex = index;
            }
        }
    };
    /**
     * 隐藏辅助点
     */
    Pie.prototype.hideHover = function () {
        this.seriesGroup
            .selectAll("." + this.ctx.classPrefix + "-chart-halo")
            .style("opacity", "0");
        this.currentHoverIndex = null;
    };
    Pie.prototype.onLegendItemHover = function (_a) {
        var key = _a.key;
        this.seriesGroup
            .selectAll("." + this.ctx.classPrefix + "-chart-series")
            .selectAll("path")
            .call(function (g) {
            g.each(function highlight(_a) {
                var data = _a.data;
                var ele = d3_1.select(this);
                if (data === key) {
                    ele.attr("opacity", 1);
                }
                else {
                    ele.attr("opacity", 0.3);
                }
            });
        });
    };
    Pie.prototype.onLegendItemLeft = function () {
        this.seriesGroup
            .selectAll("." + this.ctx.classPrefix + "-chart-series")
            .selectAll("path")
            .call(function (g) {
            g.each(function highlight() {
                var ele = d3_1.select(this);
                ele.attr("opacity", 1);
            });
        });
    };
    /**
     * 图例点击事件
     * @param legendData 被点击的图例信息
     * @param disabled 改图例元素是否是禁用状态
     */
    Pie.prototype.onLegendClick = function (legendData, disabled) {
        var key = legendData.key;
        if (disabled) {
            this.disabledKeys.push(key);
        }
        else {
            this.disabledKeys = this.disabledKeys.filter(function (d) { return d !== key; });
        }
        this.model.filterColumns(this.disabledKeys);
        this.draw(false);
    };
    return Pie;
}(shape_1.Shape));
exports.Pie = Pie;
function getPercentage(startAngle, endAngle, fixed) {
    if (fixed === void 0) { fixed = 2; }
    return parseFloat((((endAngle - startAngle) / (2 * Math.PI)) * 100).toFixed(fixed));
}
//# sourceMappingURL=pie.js.map